module.exports = __webpack_public_path__ + "img/kolor-09.46652988.png";